import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./IconBox.scss";

export default function IconBox(props) {
  const isInternal = props.cta_link && props.cta_link.startsWith("/");

  return (
    <div id={props.main_id} className="icon-box-block">
      <div className="icon-box">
        {props.icon}
      </div>
      <div className="content">
        <h3>{props.title}</h3>
        <p>{props.description}</p>
        {props.cta_label && (
          isInternal ? (
            <Button
              id={props.main_id ? `${props.main_id}_btn` : undefined}
              as={Link}
              to={props.cta_link}
              variant="outline-primary"
              className="service-btn"
            >
              {props.cta_label}
            </Button>
          ) : (
            <Button
              id={props.main_id ? `${props.main_id}_btn` : undefined}
              href={props.cta_link}
              variant="outline-primary"
              className="service-btn"
            >
              {props.cta_label}
            </Button>
          )
        )}
      </div>
    </div>
  );
}
